import { render, staticRenderFns } from "./AppInlineProfile.vue?vue&type=template&id=0b1e8dd4"
import script from "./AppInlineProfile.vue?vue&type=script&lang=js"
export * from "./AppInlineProfile.vue?vue&type=script&lang=js"
import style0 from "./AppInlineProfile.vue?vue&type=style&index=0&id=0b1e8dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports